import styled from "styled-components";
import { responsive } from "../../../../styles/constants.style";

export const ViewProjectKeyDetailsWrapper = styled.div`
  .key-detail-tab {
    padding: 16px;
    ${responsive.MOBILE`
       padding: 0px 8px 16px 8px;  
    `}
  }
`;
